import Vue from 'vue';
import App from './App.vue';
import router from './router';

import { BootstrapVue } from 'bootstrap-vue';
import VueApollo from 'vue-apollo';
import { apolloClient } from './vue-apollo';
require('core-js/features/object/entries'); // Optional IE11 support

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueApollo);

const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
});

new Vue({
    router,
    apolloProvider,
    render: h => h(App),
}).$mount('#app');
